import { LOANREQUEST_STATUSES, SUB_STATUS_INITIAL } from 'cpool-constants';
import { z } from 'zod';

import { commonSchema } from '../common';

export const schemaInitial = z
    .object({
        status: z.literal(LOANREQUEST_STATUSES.INITIAL),
        subStatus: z.nativeEnum(SUB_STATUS_INITIAL).optional(),
    })
    .merge(commonSchema);
